/**
 * Internal dependencies
 */
import { Fish, FishProfile } from '@Types/fish';

/**
 * Returns the first member profile of a fish.
 *
 * @param {Fish} fish - The fish to get the member profile from.
 * @returns {FishProfile | null} - The member profile of the fish, or null if the fish has no profiles or no member profile.
 */
export function getMemberProfile(fish: Fish): FishProfile | null {
  if (!fish || !fish.fishProfiles?.length) {
    console.error('Fish has no profiles.');
    return null;
  }

  const profile = fish.fishProfiles.find(
    (profile) => profile.profileType === 'MEMBER',
  );

  if (!profile) {
    console.error('Fish has no member profile.');
    return null;
  }

  return profile;
}

/**
 * Returns the first member profile of a fish.
 *
 * @param {Fish} fish - The fish to get the member profile from.
 * @returns {FishProfile | null} - The member profile of the fish, or null if the fish has no profiles or no member profile.
 */
export function getMemberOrFirstProfile(fish: Fish): FishProfile | null {
  if (!fish || !fish.fishProfiles?.length) {
    console.error('Fish has no profiles.');
    return null;
  }

  const profile = fish.fishProfiles.find(
    (profile) => profile.profileType === 'MEMBER',
  );

  if (!profile) {
    return fish.fishProfiles[0] ?? null;
  }

  return profile;
}
